
export default {
  name: 'ModalConfirmacaoCancelamentoFatura',
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    flagsDeControle: {
      type: [Array, Object],
      required: true
    }
  },
  data () {
    return {
      confirmarCancelamento: false
    }
  },
  methods: {
    cancelarFatura () {
      this.$emit('cancel')
    }
  }
}
